import React from 'react';

import { CONFIGURE_TAB } from '../../../constants/configure';

import { capitalizeFirstLetter } from 'services/strings';

import EmptyView from '../../../design-system/EmptyView/EmptyView';
import PlayProcessIcon from '../../../design-system/Icons/PlayProcessIcon';
import PlayCircleFillIcon from '../../../design-system/Icons/PlayCircleFillIcon';
import { AddCircleLineIcon, LoopRightFillIcon } from '../../../design-system/Icons';

const ConfigureEmptyView = ({ activeTab, handleClick }) => {
    const entity =
        {
            [CONFIGURE_TAB.processes]: 'Process',
            [CONFIGURE_TAB.playbooks]: 'Playbook',
            [CONFIGURE_TAB.cycles]: 'Cycle',
        }[activeTab] || 'Process';

    const errorSnippet = `${capitalizeFirstLetter(activeTab)} yet.`;

    const MainIcon =
        {
            [CONFIGURE_TAB.processes]: PlayCircleFillIcon,
            [CONFIGURE_TAB.playbooks]: PlayProcessIcon,
            [CONFIGURE_TAB.cycles]: LoopRightFillIcon,
        }[activeTab] || PlayCircleFillIcon;

    return (
        <EmptyView
            icon={MainIcon}
            mainText={`You don’t have any ${errorSnippet}`}
            subtext={`Try creating one by clicking “New ${entity}”.`}
            buttonText={`New ${entity}`}
            buttonLeadingIcon={AddCircleLineIcon}
            handleButtonClick={handleClick}
        />
    );
};

export default ConfigureEmptyView;
